export default "__VITE_ASSET__BIQZZFp9__"